(() => {
  const init = () => {
    const bar = document.getElementById('WagvoraStickyAtc');
    if (!bar) return;

    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const mainSubmit = mainForm && mainForm.querySelector('.product-form__submit');
    if (!mainSubmit) {
      bar.remove();
      return;
    }

    const barButton = bar.querySelector('.wv-sticky-atc__button');
    const barButtonText = barButton.querySelector('span');
    const barPrice = bar.querySelector('.wv-sticky-atc__price');
    const mainPrice = document.querySelector('[id^="price-"]');

    const sync = () => {
      barButton.disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
      const mainLabel = mainSubmit.querySelector('span');
      if (mainLabel && mainLabel.textContent.trim()) {
        barButtonText.textContent = mainLabel.textContent.trim();
      }
      if (mainPrice && barPrice) {
        const clones = Array.from(mainPrice.childNodes, (node) => node.cloneNode(true));
        barPrice.replaceChildren(...clones);
      }
    };

    const observer = new MutationObserver(sync);
    observer.observe(mainSubmit, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
    if (mainPrice) {
      observer.observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }
    sync();

    const visibility = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !scrolledPast;
    });
    visibility.observe(mainSubmit);

    barButton.addEventListener('click', () => {
      if (!mainSubmit.disabled) mainSubmit.click();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
